import React, { useState, useEffect } from "react"
import _ from "lodash"
import { alphanum } from "components/table/lib/sort"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { PercentTenantRevenue_s } from "components/line-items/line-items-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

import { NumberInput, DropdownInput, CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const PercentTenantRevenue = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    percent: null,
    revenue: null,
  }
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [data, setData] = useState<object|null>(props.rowData[props.field]);
  const [showSelected, setShowSelected] = useState<boolean>(props?.rowData[props?.field]?.items?.length > 0);
  const revenueOptions = [
    'Abatements',
    'Abatements - Recovery',
    'Abatements - Rent',
    'Absorption & Turnover Vacancy',
    'Leasing Commission',
    'Misc. Revenue',
    'Other Capital',
    'Percentage Rent',
    'Potential Rent',
    'Potential Rent + Recoveries',
    'Potential Rent + Sched. Recoveries',
    'Potential Revenue',
    'Potential Revenue w/ Sched. Recoveries',
    'Scheduled Recoveries',
    'Scheduled Rent',
    'Scheduled Rent + Recoveries',
    'Scheduled Revenue',
    'Tenant Capital',
    'Tenant Improvement'
  ]

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'percentTenantRevenue') {
      setData(emptyRecord)
      setShowSelected(false)
    }
  }, [props['rowData']])

  const updateData = (val:any, field:string) => {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)
    //clear items on first persist
    if(props['rowData'][props.field] === null || props['rowData'][props.field].state !== 'percentTenantRevenue') {
      _.set(nextData, "lineitemdetail.items", [])
    }
    _.set(nextData, "lineitemdetail.state", "percentTenantRevenue")

    let items = _.get(nextData, "lineitemdetail.items")
    if (field === 'items'){
      items = val.map(item => { return { 'rentRollId': item }})
    } else {
      localCache[field] = val
      nextData[props.field][field] = val
    }

    _.set(nextData, "lineitemdetail.items", items)
    _.set(localCache, "items", items)
    setData(localCache)

    nextData["inputtype"] = "percentTenantRevenue"
    nextData["amt"] = null
    nextData["amttype"] = null
    nextData["areaid"] = null
    nextData["inflationdetail"] = null

    delete nextData.lineitemdetail.inflation
    delete nextData.lineitemdetail.lineItemId
    delete nextData.lineitemdetail.areaMeasureNamedItemId
    delete nextData.lineitemdetail.inflateFromAnalysisBegin

    props.persist(nextData, props.field, props.rowData)
  }

  const attrs           = (field) => field_attrs('percentTenantRevenue')(field)(props.rowData, props)
  let rentRolls         = _.get(props, "namedItems.rentroll")
  let tenantRevenueData = _.map(_.get(data, "items"), item => _.get(item, "rentRollId")) || []

  if (showSelected && tenantRevenueData){
    rentRolls = rentRolls.filter(rentroll => tenantRevenueData.includes(rentroll.rentrollid));
  }

  function selectAll():void {
    data && data['items'] && data['items'].length === rentRolls.length ? updateData([], 'items') : updateData(rentRolls.map(rentroll => rentroll.rentrollid), 'items')
  }

  if (sortDirty){
    sortAsc ? rentRolls.sort((a, b) => alphanum(a.suite, b.suite)) : rentRolls.sort((a, b) => alphanum(b.suite, a.suite))
  }

  return (
    <PercentTenantRevenue_s>
      <SingleRowCarouselState_s>
        <div>
          <label>Percent</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="percent" readPrecision={4} writePrecision={4} persist={updateData} />
        </div>
        <div>
          <label>Revenue</label>
          <DropdownInput className="automated" data={data} field="revenue" options={revenueOptions} persist={updateData} attrs={attrs}/>
        </div>
      </SingleRowCarouselState_s>
      <br />
      <SingleRowCarouselState_s>
        <div>
          <label>Show Selected</label>
          <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
        </div>
        <ListboxSection_s>
          <ListboxHeaderSort_s>
            <label>Tenants</label>
            <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
              { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
              { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
            </a>
          </ListboxHeaderSort_s>
          <SelectAllCheckbox_s className="automated" data={{allSelected: tenantRevenueData ? tenantRevenueData.length === rentRolls.length : false}} field='allSelected' persist={selectAll} />
          <ListboxInput
            className="automated"
            data={{"items": tenantRevenueData}}
            attrs={attrs}
            field="items"
            multiple={true}
            persist={updateData}
            options={rentRolls.map(rentroll => { return {label: `${rentroll.sortorder} - ${rentroll.suite}: ${rentroll.tenant}`, value: rentroll.rentrollid}})}
          />
        </ListboxSection_s>
      </SingleRowCarouselState_s>
    </PercentTenantRevenue_s>
  )
}

export default PercentTenantRevenue
